import Vue from 'vue'
import { GetterTree, MutationTree, ActionTree } from 'vuex'

import format from 'date-fns/format'
import fromUnixTime from 'date-fns/fromUnixTime'
import { enUS, de } from 'date-fns/locale'
import _sample from 'lodash/sample'

import { isMediumScreen } from '../service/utils'

import i18n from '@/i18n'

class State {
    _associationsSeen: Array<number> = []
    _gameMode = 'image'
    _sawIntro = false
    _consentSettingsOpen = true
    _trackingAllowed = false
}

const getters = {
    formattedDate() {
        return ( timestamp: number ) => format( fromUnixTime( timestamp ), 'dd. LLLL y', {
            locale: i18n.locale === 'en' ? enUS : de
        } )
    },
    sawIntro( state ): boolean {
        return state._sawIntro
    },
    consentSettingsOpen( state ): boolean {
        return state._consentSettingsOpen
    },
    trackingAllowed( state ): boolean {
        return state._trackingAllowed
    }
} as GetterTree<State, any>

const mutations = {
    setIntroState( state ) {
        Vue.set( state, '_sawIntro', true )
    },
    setBodyFixed() {
        const bodyElement = document.body

        if ( isMediumScreen() ) return

        if ( bodyElement.classList.contains( 'oe-fixed-body' ) ) {
            bodyElement.classList.remove( 'oe-fixed-body' )
        } else {
            bodyElement.classList.add( 'oe-fixed-body' )
        }
    },
    removeFixedBody() {
        const bodyElement = document.body

        bodyElement.classList.remove( 'oe-fixed-body' )
    },
    setTrackingAllowed( state, status ) {
        Vue.set( state, '_trackingAllowed', status )
    },
    hideConsent( state ) {
        Vue.set( state, '_consentSettingsOpen', false )
    },
    showConsent( state ) {
        Vue.set( state, '_consentSettingsOpen', true )
    }
} as MutationTree<State>

const actions = {
    getRandomUserName( { dispatch } ) {
        // needs rework
        dispatch( 'fetchAndAdd' ).then( ( result ) => {
            console.log( result )
            const starNames: Array<string> = result.starNames
            const randomStarName = _sample( starNames )

            if ( randomStarName ) {
                starNames.slice( starNames.indexOf( randomStarName ), 1 )
            }

            dispatch( 'patch', {
                starNames: starNames
            } ).then( () => randomStarName )
        } )
    }
} as ActionTree<State, any>

const GlobalModule = {
    moduleName: 'globalModule',
    namespaced: true,
    state: new State(),
    mutations,
    getters,
    actions
}

export default GlobalModule